import { render, staticRenderFns } from "./RptPreciosMInisoComponent.vue?vue&type=template&id=54cf103d&"
import script from "./RptPreciosMInisoComponent.vue?vue&type=script&lang=js&"
export * from "./RptPreciosMInisoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports